import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class MultipleForceDownloadLoadPathFilesCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) { }

  async run(company_id:Number): Promise<any> {
    let args = { 
      company_ids: [company_id]
    }
    await this.dispatcher.dispatch('multiple_download_load_path_files', args)
  }
}